import { Options } from "common";
import api from "app/api";

export type OpenapiKeyListItem = {
  id: number;
  name: string;
};
export type OpenapiKeyFormItem = {
  id: number;
  key?: string;
  name: string;
  enabled: number;
  permissions: string[];
  account_id: number;
  created_at: string;
  created_by: number;
  deleted_at: string;
  deleted_by: number;
};

export type OpenapiKeyOptions = Options<"permissions">;

export function getOpenapiKeyService() {
  return api.getService<OpenapiKeyFormItem, OpenapiKeyListItem, OpenapiKeyOptions>(
    "openapi-keys",
    {
      itemExporter: item => {
        return {
          OpenapiKeyForm: item
        };
      },
    }
  );
}
